import { CarDetails } from '../../CarDetails';
import { Heading } from '../../Heading';
import { PercPickupLocation } from '../../../../graphql';
import { Drawer } from '../../../../components/Drawer';
import { RadioButton } from '../../../../components/RadioButton';

export type ParkingLotPickupOptionProps = {
	showInDrawer: boolean;
	parkingLotActive: boolean;
	clickHandler: (pickupLoaction: PercPickupLocation) => void;
};

const Inner: React.FC<ParkingLotPickupOptionProps> = ({
	showInDrawer,
	parkingLotActive,
	clickHandler
}) => {
	if (!showInDrawer) {
		return (
			<>
				<Heading>Wait in parking lot</Heading>

				<CarDetails isActive={parkingLotActive} />
			</>
		);
	}

	return (
		<Drawer
			isActive={parkingLotActive}
			style={{
				marginLeft: -15,
				paddingLeft: 15
			}}
		>
			<RadioButton
				className="py-3"
				id="parkingLot"
				value="PARKING_LOT"
				label="Wait in parking lot"
				clickHandler={() => clickHandler('PARKING_LOT')}
				active={parkingLotActive}
			/>

			<CarDetails isActive={parkingLotActive} />
		</Drawer>
	);
};

export const ParkingLotPickupOption: React.FC<
	ParkingLotPickupOptionProps
> = props => (
	<div className="checkout-pickup-method-parking-lot-pickup-option">
		<Inner {...props} />
	</div>
);
